/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const fieldMappingSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  discoveryStatus: z.enum(['DISCOVERING', 'DONE', 'NOT_FOUND', 'FAILED']).nullish(),
  fieldSource: z.enum(['CREATE_META', 'EDIT_META']).nullish(),
  id: z.int(),
  integrationInstanceId: z.int(),
  mapName: z.string(),
  organizationId: z.string(),
  sampleIssueKey: z.string().nullish(),
  sampleIssueTypeId: z.string().nullish(),
  sampleProjectId: z.string().nullish(),
  sourceFieldId: z.string().nullish(),
  sourceFieldName: z.string(),
  sourceFieldType: z.enum([
    'SELECT',
    'MULTI_SELECT',
    'DATE',
    'DATETIME',
    'TEXT',
    'MULTILINE_TEXT',
    'NUMERIC',
    'CHECKBOX',
    'MULTI_CHECKBOX',
    'USER',
    'MULTI_USER',
    'TEAM',
    'VERSION',
    'COMPONENT',
    'LABELS',
  ]),
  state: z.enum(['ACTIVE', 'TEMPO_FIELD_DELETED']),
  tempoFieldId: z.int(),
  tempoFieldName: z.string(),
  tempoFieldType: z.enum([
    'CHECKBOX',
    'CURRENCY',
    'DATE',
    'ITEM',
    'LINK',
    'MULTI_CUSTOMER',
    'MULTI_ITEM',
    'MULTI_LINK',
    'MULTI_PICKLIST',
    'MULTI_TEXT',
    'MULTI_USER',
    'MULTILINE_TEXT',
    'NOTE',
    'NUMERIC',
    'PICKLIST',
    'TEXT',
    'USER',
  ]),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  validProjectIds: z.array(z.string()).nullish(),
});
